/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElement as defineHmcLabsCol } from '@adi-ctx/harmonic-labs/dist/components/hmc-labs-col.js';
import { defineCustomElement as defineHmcLabsGrid } from '@adi-ctx/harmonic-labs/dist/components/hmc-labs-grid.js';
import { defineCustomElement as defineHmcLabsRow } from '@adi-ctx/harmonic-labs/dist/components/hmc-labs-row.js';
export const HmcLabsCol = /*@__PURE__*/ createReactComponent('hmc-labs-col', undefined, undefined, defineHmcLabsCol);
export const HmcLabsGrid = /*@__PURE__*/ createReactComponent('hmc-labs-grid', undefined, undefined, defineHmcLabsGrid);
export const HmcLabsRow = /*@__PURE__*/ createReactComponent('hmc-labs-row', undefined, undefined, defineHmcLabsRow);
